import script from "./acDataTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./acDataTable.vue?vue&type=script&setup=true&lang=ts"

import "./acDataTable.vue?vue&type=style&index=0&id=1971ca8a&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1971ca8a"]])

export default __exports__